(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 let paused = reduced.matches;const updates=[];
 document.querySelectorAll('[data-prompt-preview]').forEach(video => {
  video.muted = true;
  const showFrame = () => { if (video.readyState >= 2) video.classList.add("has-preview-frame"); };
  video.addEventListener("loadeddata", showFrame);
  showFrame();
  video.addEventListener("error", () => video.classList.remove("has-preview-frame"));
  let visible = false;
  const update = () => {
   if (visible && !document.hidden && !reduced.matches && !paused) video.play().catch(() => {});
   else video.pause();
  };
  new IntersectionObserver(entries => {visible = entries[0].isIntersecting; update();}, {threshold: .2}).observe(video);
  updates.push(update);
  document.addEventListener('visibilitychange', update);
  reduced.addEventListener('change', update);
 });
 document.querySelectorAll('.home-prompt-examples').forEach(root => {
  const pause=root.querySelector('[data-prompt-pause]');
  function paintPause(){pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?pause.dataset.playLabel:pause.dataset.pauseLabel;updates.forEach(update=>update());}
  pause.addEventListener('click',()=>{paused=!paused;paintPause();});
  reduced.addEventListener('change',()=>{paused=reduced.matches;paintPause();});paintPause();
  const track = root.querySelector('.home-prompt-examples__grid');
  const move = direction => {
   const card = track.querySelector('.home-prompt-example');
   const gap = parseFloat(getComputedStyle(track).gap) || 16;
   track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: reduced.matches ? 'instant' : 'smooth'});
  };
  root.querySelector('[data-prompt-prev]').addEventListener('click', () => move(-1));
  root.querySelector('[data-prompt-next]').addEventListener('click', () => move(1));
 });
})();

